import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ecm-mat-seo-login',
    templateUrl: 'material-seo-login.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslateModule, NgClass],
})
export class MaterialSeoLoginComponent {
    public i18nPath = 'material.seo.login';

    @Input() public e2e = 'e2e-mat-seo-login';
    @Input() public style: 'primary' | 'secondary' = 'primary';
    @Input() public ariaLabel: string;

    @Output() public login = new EventEmitter<void>();
    @Output() public findIdentifier = new EventEmitter<void>();
}
